
import axios from "axios";
import { Config } from "../../../core/config/config";
import { processLoadOptions } from "@/core/helper/datasource-query-helper";

const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/replenishment/preorder`;

export const preorderService = {

    getPreorder: async function (preOrderId: any, vendorId: any, categoryCode1: any, productId: any, cutOffCode: any, isOrderDay: any) {
        return axios.get(`${GATEWAY_URL}/list`, {
            params: {
                PreOrderId: preOrderId,
                VendorCode: vendorId,
                CategoryCode1: categoryCode1,
                ProductCode: productId,
                CutOffCode: cutOffCode,
                IsOrderDay: isOrderDay,
                IsVendorApproved: 0
            }
        })
            .then((response) => {
                return response.data;
            });
    },
    getVendorSummaries: async function (PreOrderId: any
        , VendorCode: string
        , CategoryCode1: string
        , ProductCode: string
        , CutOffCode: string) {
        return axios.get(`${GATEWAY_URL}/vendor_summaries`, {
            params: {
                PreOrderId: PreOrderId,
                VendorCode: VendorCode,
                CategoryCode1: CategoryCode1,
                ProductCode: ProductCode,
                CutOffCode: CutOffCode
            }
        })
            .then((response) => {
                return response.data;
            });
    },

    getLocationsLookups: async function (loadOptions: any) {
        return axios.get(`${GATEWAY_URL}/locations`, {
        })
            .then((response) => {
                return response.data;
            });
    },

    getVendorsLookups: async function (preOrderId: any) {
        return axios.get(`${GATEWAY_URL}/vendors`, {
            params: {
                PreOrderId: preOrderId
            }
        })
            .then((response) => {
                return response.data;
            });
    },

    getCutOffsLookups: async function (preOrderId: any) {
        return axios.get(`${GATEWAY_URL}/cutoffs`, {
            params: {
                PreOrderId: preOrderId
            }
        })
            .then((response) => {
                return response.data;
            });
    },

    getCategoriesLookups: async function (preOrderId: any) {
        return axios.get(`${GATEWAY_URL}/categories`, {
            params: {
                PreOrderId: preOrderId
            }
        })
            .then((response) => {
                return response.data;
            });
    },

    getProductsLookups: async function (preOrderId: any) {
        return axios.get(`${GATEWAY_URL}/products`, {
            params: {
                PreOrderId: preOrderId
            }
        })
            .then((response) => {
                return response.data;
            });
    },


    deleteResource: async function (params: any) {
        return axios.delete(`${GATEWAY_URL}/delete-resource`, {
            params
        })
            .then((response) => {
                return response.data;
            });
    },

    updatePreorder: async function (key: any, values: any) {
        return axios.post(`${GATEWAY_URL}/approvedqty`, values)
            .then((response) => {
                return response.data;
            });
    },


    updatePreorderBatch: async function (values: any, locationCode: string) {
        return axios.put(`${GATEWAY_URL}/qty_approvement`,
            values,
            {
                params: {
                    locationCode: locationCode,
                }
            })
            .then((response) => {
                return response.data;
            });
    },

    venderApproveFunc: async function (preOrderId: number, vendorCode: string, locationCode: string) {
        return axios.get(`${GATEWAY_URL}/vendor_approvement`, {
            params: {
                PreOrderId: preOrderId,
                VendorCode: vendorCode,
                LocationCode: locationCode,
            }
        })
            .then((response) => {
                return response.data;
            });
    },


    getChartData: async function (ordersLinesId: any) {
        return axios.get(`${GATEWAY_URL}/sale_chart`, {
            params: {
                OrdersLinesId: ordersLinesId
            }
        })
            .then((response) => {
                return response.data;
            });
    }
}

